<div class="modal-header">
    <button type="button"
            class="close swapa-close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body" ngbAutofocus>
    <iframe id="videoIframe"
            width="100%"
            height="400"
            [src]="safeUrl"
            title=""
            frameborder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="activeModal.close()" data-dismiss="modal">
        Close
    </button>
</div>
